import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { LayoutDashboard, FileText, Settings } from "lucide-react";
import "./coach-team-member-layout.scss";
import CoachTeamMemberHeader from "./coach-team-member-header";
import { CoachTeamMemberSidebar } from "./coach-team-member-sidebar";

const navItems = [
  {
    id: "dashboard",
    href: "/dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    id: "resources",
    href: "/resources",
    label: "Resources",
    icon: FileText,
  },
  {
    id: "settings",
    href: "/profile",
    label: "Settings",
    icon: Settings,
  },
];

export default function CoachTeamMemberLayout() {
  const location = useLocation();
  const isCourse = /^\/course\//.test(location.pathname);
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Course view keeps its focused, full-screen experience with the top header.
  if (isCourse) {
    return (
      <>
        <CoachTeamMemberHeader />
        <div className="page-bg page-bg--course">
          <div className="main-content main-content--course d-flex flex-column w-100">
            <Outlet />
          </div>
        </div>
      </>
    );
  }

  // Dashboard / Resources / Settings use the sidebar layout
  // (same behaviour as Business and Admin users).
  return (
    <div className="page-bg">
      <CoachTeamMemberSidebar
        isCollapsed={isCollapsed}
        onToggle={() => setIsCollapsed(!isCollapsed)}
        navItems={navItems}
      />
      <div
        className={`main-content d-flex flex-column w-100 ${
          isCollapsed ? "sidebar-collapsed" : "sidebar-expanded"
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
}
